import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { Page404Component } from './extrapages/page404/page404.component';

import { LayoutComponent } from './layouts/layout/layout.component';
import { AgendaComponent } from './pages/planning/agenda/agenda.component';
import { CalendrierComponent } from './pages/planning/calendrier/calendrier.component';

const routes: Routes = [
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  // tslint:disable-next-line: max-line-length
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },
  { path: 'pages', loadChildren: () => import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule), canActivate: [AuthGuard] },
  {path: '404', component: Page404Component},
  {path: '**', redirectTo: '/404'},
  { path: 'planning/agenda', component: AgendaComponent, canActivate: [AuthGuard] },
  { path: 'planning/planning', component: CalendrierComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
